/**
 * @param {Array<String>} list
 * @return {String}
 */
export default function getClassNames(list) {
  return [...list].filter(name => name).join(" ");
}
